export default {
  inAndOutStore: {
    column: {
      gmtCreate: '创建时间',
      createBy: '创建人',
      departmentName: '部门',
      companyName: '公司名',
      orderNo: '订单号',
      orgName: '公司',
      projectCode: '项目代码',
      projectName: '项目名称',
      periodName: '账期',
      productCode: '商品编码',
      productName: '商品名称',
      productSpec: '规格型号',
      reportDate: '日期',
      reportDateStart: '开始日期',
      reportDateEnd: '结束日期',
      businessCompanyCode: '业务公司编码',
      businessCompanyName: '业务公司',
      businessDepartmentCode: '业务部门编码',
      businessDepartmentName: '业务部门',
      opening: '期初',
      openingCount: '数量',
      openingAmountWithoutTax: '不含税金额',
      current: '本期',
      currentInboundCount: '入库数',
      currentTotalInboundCount: '累计生产入库',
      currentCostPrice: '入库成本',
      currentTotalCostAmount: '累计生产成本',
      currentAvgPrice: '单位加权平均成本',
      daySalesCount: '销售数量',
      totalSalesCount: '累计销售数量',
      daySalesCostAmount: '销售成本',
      totalSalesCostAmount: '累计销售成本',
      end: '期末',
      endCount: '数量',
      endAmountWithoutTax: '不含税金额',
    },
    label: {
      gmtCreate: '创建时间',
      createBy: '创建人',
      departmentName: '部门',
      companyName: '公司名',
      projectCode: '项目代码',
      projectName: '项目名称',
      reportDate: '日期',
      businessCompanyCode: '业务公司编码',
      businessCompanyName: '业务公司名称',
      businessDepartmentCode: '业务部门编码',
      businessDepartmentName: '业务部门名',
      openingCount: '期初数量',
      openingAmountWithoutTax: '期初不含税金额',
      currentInboundCount: '本期入库数',
      currentTotalInboundCount: '本期累计生产入库',
      currentCostPrice: '本期入库成本',
      currentTotalCostAmount: '本期累计生产成本',
      currentAvgPrice: '本期单位加权平均成本',
      daySalesCount: '本期本日销售数量',
      totalSalesCount: '本期累计销售数量',
      daySalesCostAmount: '本期本日销售成本',
      totalSalesCostAmount: '本期累计销售成本',
      endCount: '期末数量',
      endAmountWithoutTax: '期末不含税金额',
    },
    form: {
      basicDetailInfo: '基本信息',
      basicDetailPct: '配方行项目',
      salesSpecification: '销售规格',
      constructionSpecification: '施工规格',
      costingCost: '成本计算',
      importType: '选择入库类型导入',
    },
    table: {
      sortNo: '序号',
    },
    buttons: {
      error: 'Operation failed!',
      confirm: 'Confirm',
      save: '保存',
      submit: '提交',
      upload: '上传附件',
      add: '增加',
      delete: '删除',
    },
    message: {
      noData: '您还未选择任何数据',
      pleaseSelectOne: '请选择一条数据操作',
      topFormCheckResult: '请您将数据填写完整',
      deleteSuccess: '删除成功',
      baseDataIncomplete: '请将基本数据填写完整',
      salesDataIncomplete: '请将销售数据填写完整',
      purchasingDataIncomplete: '请将采购数据填写完整',
      is_expandApply: '数据已存在，是否扩展申请',
      return_listPage: '返回合作伙伴主数据页面',
      data_repeat: '已存在该数据',
      cancelled: '已取消',
      canNotChange: '该数据状态不可编辑',
      enableTo_forbid: '启用只针对已禁用的状态',
      forbidTo_enable: '禁用只针对已生效的状态',
      mergeNeed_enable: '合并功能针对已生效的数据',
      saveSuccess: '保存成功',
      noProjectCode: '请选择项目名称',
      noPeriodName: '请选择账期',
      noBusinessDepartmentCode: '请选择部门',
      noReportDateStart: '请选择开始日期',
    },
    options: {
      domesticTrade: '内贸',
      generalTrade: '一般贸易',
      feedProcessing: '进料加工',
    },
  },
};
